import { todayIstDateKey } from './serviceWorkStorage';

/** Lobby / desk lists only show same-calendar-day visits (IST), matching server expires_on. */
export function isCheckinForToday(checkin) {
  if (!checkin) return false;
  const today = todayIstDateKey();
  const expires = String(checkin.expires_on || '').slice(0, 10);
  if (expires) return expires === today;
  const checkedIn = String(checkin.checked_in_at || '').slice(0, 10);
  if (checkedIn) return checkedIn === today;
  return false;
}

export function filterCheckinsForToday(list) {
  return (Array.isArray(list) ? list : []).filter(isCheckinForToday);
}
